<template>
    <AddPupils callerRole="admin" :pupils="pupils" :classes="classes" :addUsers="addUsers" />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useAdminStore } from '~/stores/admin';
import { ParsedUser } from '@ilteducation/giglets-types';

definePage({ meta: { area: 'pupils' } });
const store = useAdminStore();
store.fetchClasses();
store.fetchPupils();

const { pupils, classes } = storeToRefs(store);

const addUsers = async (type: 'pupil' | 'teacher', users: ParsedUser[]) => {
    await store.addUsers(type, users);
};
</script>
